export default __webpack_public_path__ + "static/media/moonwhale.65e283c1.png";